(function(){
  const $ = (s,c)=> (c||document).querySelector(s);
  const $$ = (s,c)=> Array.from((c||document).querySelectorAll(s));
  const money = c => '$' + (c/100).toFixed(2);

  // built-in Diva gateway pages: avoids Shopify 404s for section cards
  const requestedSection = new URLSearchParams(window.location.search).get('diva_section');
  if(['jewellery','fashion','gifts'].includes(requestedSection)){
    const pagesWrap = $('[data-diva-section-pages]');
    if(pagesWrap){
      pagesWrap.hidden = false;
      $$('.gateway,.value-props,.featured-collection').forEach(el=> el.hidden = true);
      $$('[data-diva-page],[data-diva-products]').forEach(el=> el.classList.remove('is-active'));
      $$(`[data-diva-page="${requestedSection}"],[data-diva-products="${requestedSection}"]`).forEach(el=> el.classList.add('is-active'));
      document.title = `${requestedSection.charAt(0).toUpperCase()+requestedSection.slice(1)} – Diva Wants`;
      window.scrollTo({top:0, behavior:'instant'});
    }
  }

  // mobile nav
  const nav = $('[data-nav]'), burger = $('[data-nav-toggle]');
  if(burger) burger.addEventListener('click', ()=> nav.classList.toggle('is-open'));

  // cart drawer
  const drawer = $('#CartDrawer');
  const open = ()=>{ drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden','false'); refreshCart(); };
  const close = ()=>{ drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden','true'); };
  $$('[data-cart-open]').forEach(b=>b.addEventListener('click', open));
  $$('[data-cart-close]').forEach(b=>b.addEventListener('click', close));

  async function refreshCart(){
    try{
      const res = await fetch('/cart.js', {headers:{'Accept':'application/json'}});
      const cart = await res.json();
      const body = $('[data-cart-body]'), foot = $('[data-cart-foot]');
      $$('[data-cart-count]').forEach(el=> el.textContent = cart.item_count);
      if(!cart.items.length){
        body.innerHTML = '<p class="cart-drawer__empty">Your cart is empty.</p>';
        foot.hidden = true; return;
      }
      body.innerHTML = cart.items.map(i=>`
        <div class="cart-drawer__item">
          ${i.image?`<img src="${i.image}" alt="">`:'<div></div>'}
          <div>
            <strong>${i.product_title}</strong>
            <div class="muted" style="font-size:.85rem">Qty ${i.quantity} · ${money(i.final_line_price)}</div>
          </div>
          <button aria-label="Remove" data-remove="${i.key}" style="background:none;border:0;cursor:pointer">&times;</button>
        </div>`).join('');
      $('[data-cart-subtotal]').textContent = money(cart.total_price);
      foot.hidden = false;
      $$('[data-remove]').forEach(b=> b.addEventListener('click', async ()=>{
        await fetch('/cart/change.js', {method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({id:b.dataset.remove, quantity:0})});
        refreshCart();
      }));
    }catch(e){ console.error(e) }
  }

  // ajax add
  $$('[data-product-form]').forEach(form=>{
    form.addEventListener('submit', async e=>{
      e.preventDefault();
      const fd = new FormData(form);
      const res = await fetch('/cart/add.js', {method:'POST', body:fd, headers:{'Accept':'application/json'}});
      if(res.ok){ open(); }
      else { alert('Could not add to cart'); }
    });
  });

  // wishlist (localStorage)
  const KEY='diva_wishlist';
  const wish = ()=> JSON.parse(localStorage.getItem(KEY)||'[]');
  const setWish = a => localStorage.setItem(KEY, JSON.stringify(a));
  $$('[data-wishlist]').forEach(b=>{
    const id = b.dataset.id;
    if(wish().includes(id)) b.classList.add('is-active');
    b.addEventListener('click', e=>{
      e.preventDefault();
      let a = wish();
      a = a.includes(id) ? a.filter(x=>x!==id) : a.concat(id);
      setWish(a); b.classList.toggle('is-active');
    });
  });

  // auto-tag elements for scroll reveal
  const revealSelectors = ['.gateway__head','.gateway__card','.value-prop','.featured-collection__head','.product-grid > *','.collection-hero__inner','.fashion-hero__text','.fashion-hero__media','.chip','.site-footer__grid > *'];
  revealSelectors.forEach(sel=>{
    $$(sel).forEach((el,i)=>{
      if(!el.hasAttribute('data-reveal')) el.setAttribute('data-reveal','');
      if(i<4 && !el.hasAttribute('data-delay')) el.setAttribute('data-delay', String(i));
    });
  });

  // IntersectionObserver scroll reveal
  if('IntersectionObserver' in window){
    const io = new IntersectionObserver((entries)=>{
      entries.forEach(en=>{
        if(en.isIntersecting){ en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    },{rootMargin:'0px 0px -8% 0px', threshold:.08});
    $$('[data-reveal]').forEach(el=> io.observe(el));
  } else {
    $$('[data-reveal]').forEach(el=> el.classList.add('is-in'));
  }

  // sticky header shrink on scroll
  const header = $('.site-header');
  if(header){
    const onScroll = ()=> header.classList.toggle('is-scrolled', window.scrollY > 40);
    window.addEventListener('scroll', onScroll, {passive:true}); onScroll();
  }

  // subtle parallax for hero media
  const parallaxEls = $$('.collection-hero__media, .gateway__media');
  parallaxEls.forEach(el=> el.setAttribute('data-parallax',''));
  if(parallaxEls.length){
    let raf;
    const tick = ()=>{
      const y = window.scrollY;
      parallaxEls.forEach(el=>{
        const r = el.getBoundingClientRect();
        if(r.bottom < 0 || r.top > window.innerHeight) return;
        const speed = el.classList.contains('collection-hero__media') ? .25 : .12;
        const offset = (r.top - window.innerHeight/2) * -speed;
        el.style.transform = `translate3d(0,${offset.toFixed(1)}px,0) scale(1.08)`;
      });
      raf = null;
    };
    window.addEventListener('scroll', ()=>{ if(!raf) raf = requestAnimationFrame(tick); }, {passive:true});
    tick();
  }
})();
